import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastListComponent } from './toast-list.component';
import { ToastModule } from './toast.module';

@NgModule({
  declarations: [ToastListComponent],
  imports: [CommonModule, BrowserAnimationsModule, ToastModule],
  exports: [ToastListComponent],
})
export class ToastListModule {}
